import React from 'react';
import {FooterWrapper, LogoSectionWrapper, PageWrapper, RightPart} from './styles';
import {LogoSection} from '../Auth/LogoSection';
import {ForgotPasswordFormEmail} from './ForgotPasswordForm';
import {useForgotPasswordT} from '../../hooks/auth';
import {isMobile} from '../../ui-kit/theme/breakpoints';

type ForgotPasswordPropsT = {
  forgotData: useForgotPasswordT;
};

export const ForgotPassword: React.FC<ForgotPasswordPropsT> = ({forgotData}) => {
  return (
    <PageWrapper>
      {!isMobile && (
        <LogoSectionWrapper>
          <LogoSection />
        </LogoSectionWrapper>
      )}
      <RightPart>
        {forgotData?.isEmailReset && <ForgotPasswordFormEmail forgotData={forgotData} />}
        <FooterWrapper />
      </RightPart>
    </PageWrapper>
  );
};
